import { STORAGE_KEY_ON_BOARDING_DELETE_HIDE } from '../../constants/config';
import { getLocalStorage } from './getLocalStorage';
export var hideOnBoardingDeleteVisible = function hideOnBoardingDeleteVisible() {
  var storage = getLocalStorage();
  if (storage) {
    storage.setItem(STORAGE_KEY_ON_BOARDING_DELETE_HIDE, '1');
  }
};